"use client"

import { Grid2x2X } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Grid2x2XIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Grid2x2XIcon = component(Icon)({ as: Grid2x2X })
